import { createScrollFade } from '../utils/scrollFade'

/**
 * Reveal content as it scrolls into view. `[data-reveal]` fades + slides up and
 * batches neighbours into a stagger; `[data-reveal-soft]` fades opacity only —
 * for position-sensitive elements (the sticky detail image, the map) where a
 * transform is unwanted.
 */
export function initReveals() {
  createScrollFade('[data-reveal]')
  createScrollFade('[data-reveal-soft]', { y: 0 })
  createScrollFade('[data-reveal-soft-slow]', { y: 0, start: 'top 20%' })
}
